import DropdownControl from '../dropdown/DropdownControl'
import ListSelector from './ListSelector'
import { User } from '../user-selector/User'
import ButtonControl from '../button-control'
import UserList from './UserList'
import { IconProps } from '../assets'

interface DynamicUserListProps {
  header: (close: () => void) => JSX.Element
  buttonTitle: string | JSX.Element
  icon?: IconProps['icon']
  onUserClick: (user: User) => Promise<any>
  newStyle?: boolean
  align?: 'left' | 'right'
  fetchUrl: string
  feature: string
  placeholder: string
  hasModal?: boolean
}

const DynamicUserList = ({ header, buttonTitle, icon, onUserClick, newStyle = false, align, fetchUrl, feature, placeholder, hasModal }: DynamicUserListProps) =>
  <div className={newStyle ? 'dynamic-user-list' : ''}>
    <DropdownControl
      align='adjust'
      triggerClass={icon && 'dropdown-wrapper'}
      trigger={
        <ButtonControl
          icon={icon}
          title={buttonTitle}
          newStyle={newStyle}
          size={newStyle ? 'medium' : 'small'}
          // eslint-disable-next-line @gorazdo/preact/prefer-classname
          class={`qa-topic-moderation-${feature}`}
        />
            }
      items={[]}
      onTriggerClicked={({ close }: { close: () => void }) =>
        <ListSelector
          align={align}
          isDynamic
          header={header(close)}
          hasSearch
          fetchUrl={fetchUrl}
          placeholder={placeholder}
          feature={feature}
        >
          {(users: User[]) => <div>
            {hasModal ? <UserList users={users} onClick={onUserClick} /> : <UserList users={users} onClick={async (user: User) => await onUserClick(user).then(() => close())} />}
          </div>}
        </ListSelector>}
    />
  </div>
export default DynamicUserList
